import { Component, OnInit } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';

@Component({
  selector: 'app-need-payment-type',
  templateUrl: './need-payment-type.component.html',
  styleUrls: ['./need-payment-type.component.css']
})
export class NeedPaymentTypeComponent implements OnInit {

  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeigth: any = window.innerHeight;

  constructor() { }

  ngOnInit() {
    this.eventHeight.subscribe(event => {
      this.innerHeigth = event.currentTarget.innerHeight;
    })
  }

}
